"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupedRewards = void 0;
exports.getAvailableRewards = getAvailableRewards;
exports.getAutoCompoundTxb = getAutoCompoundTxb;
exports.getDoubleAssetAutoCompoundTxb = getDoubleAssetAutoCompoundTxb;
exports.getSingleAssetOneAutoCompoundTxb = getSingleAssetOneAutoCompoundTxb;
exports.getSingleAssetTwoAutoCompoundTxb = getSingleAssetTwoAutoCompoundTxb;
exports.getLoopingPoolsAutoCompoundTxb = getLoopingPoolsAutoCompoundTxb;
exports.getAutoCompoundSingleTxb = getAutoCompoundSingleTxb;
exports.getAutocompoundRequired = getAutocompoundRequired;
const transactions_1 = require("@mysten/sui/transactions");
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const index_js_1 = require("../protocol/index.js");
const alphalend_sdk_1 = require("@alphafi/alphalend-sdk");
const lending_1 = require("@naviprotocol/lending");
const naviPolyfill_js_1 = require("./naviPolyfill.js");
async function getAvailableRewards(address) {
    return await (0, naviPolyfill_js_1.withNaviFetch)(async () => {
        const rewards = await (0, lending_1.getUserAvailableLendingRewards)(address);
        // Convert array to map organized by asset coin type (with 0x prefix)
        const rewardsByAsset = new Map();
        if (Array.isArray(rewards)) {
            for (const reward of rewards) {
                const assetKey = reward.assetCoinType;
                if (assetKey) {
                    if (!rewardsByAsset.has(assetKey)) {
                        rewardsByAsset.set(assetKey, []);
                    }
                    rewardsByAsset.set(assetKey, [
                        ...rewardsByAsset.get(assetKey),
                        reward,
                    ]);
                }
            }
        }
        return rewardsByAsset;
    });
}
async function getAutoCompoundTxb() {
    const txb = new transactions_1.Transaction();
    const C = (0, alphafi_sdk_1.getConf)();
    Object.keys(alphafi_sdk_1.poolInfo).forEach((key) => {
        const poolName = key;
        if (alphafi_sdk_1.poolInfo[key].poolId == "" || key == "NAVI-WUSDC") {
            return;
        }
        const pool = alphafi_sdk_1.poolInfo[key];
        if (pool.parentProtocolName === "BLUEFIN") {
            if (poolName === "BLUEFIN-SUI-USDC") {
                txb.moveCall({
                    target: `${pool.packageId}::alphafi_bluefin_sui_first_pool::update_pool_v2`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList["SUI"].type,
                        alphafi_sdk_1.coinsList["USDC"].type,
                        alphafi_sdk_1.coinsList["BLUE"].type,
                        alphafi_sdk_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_4_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(C.BLUEFIN_SUI_USDC_POOL),
                        txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                        txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                        txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-SUI-BUCK") {
                txb.moveCall({
                    target: `${pool.packageId}::alphafi_bluefin_sui_first_pool::update_pool_v2`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList["SUI"].type,
                        alphafi_sdk_1.coinsList["BUCK"].type,
                        alphafi_sdk_1.coinsList["BLUE"].type,
                        alphafi_sdk_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_4_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(C.BLUEFIN_SUI_BUCK_POOL),
                        txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                        txb.object(alphafi_sdk_1.cetusPoolMap["BUCK-SUI"]),
                        txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                        txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-USDT-USDC") {
                txb.moveCall({
                    target: `${pool.packageId}::alphafi_bluefin_type_1_pool::update_pool_v2`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList["USDT"].type,
                        alphafi_sdk_1.coinsList["USDC"].type,
                        alphafi_sdk_1.coinsList["BLUE"].type,
                        alphafi_sdk_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_4_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(C.BLUEFIN_USDT_USDC_POOL),
                        txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                        txb.object(alphafi_sdk_1.cetusPoolMap["USDC-USDT"]),
                        txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                        txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-AUSD-USDC") {
                txb.moveCall({
                    target: `${pool.packageId}::alphafi_bluefin_type_1_pool::update_pool_v2`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList["AUSD"].type,
                        alphafi_sdk_1.coinsList["USDC"].type,
                        alphafi_sdk_1.coinsList["BLUE"].type,
                        alphafi_sdk_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_4_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(C.BLUEFIN_AUSD_USDC_POOL),
                        txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                        txb.object(alphafi_sdk_1.cetusPoolMap["USDC-AUSD"]),
                        txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                        txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-SUI-AUSD") {
                txb.moveCall({
                    target: `${pool.packageId}::alphafi_bluefin_sui_first_pool::update_pool_v2`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList["SUI"].type,
                        alphafi_sdk_1.coinsList["AUSD"].type,
                        alphafi_sdk_1.coinsList["BLUE"].type,
                        alphafi_sdk_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_4_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(C.BLUEFIN_SUI_AUSD_POOL),
                        txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                        txb.object(alphafi_sdk_1.cetusPoolMap["AUSD-SUI"]),
                        txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                        txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-ALPHA-USDC") {
                txb.moveCall({
                    target: `${pool.packageId}::alphafi_bluefin_type_2_pool::update_pool_v2`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList["ALPHA"].type,
                        alphafi_sdk_1.coinsList["USDC"].type,
                        alphafi_sdk_1.coinsList["BLUE"].type,
                        alphafi_sdk_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_4_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(C.BLUEFIN_ALPHA_USDC_POOL),
                        txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                        txb.object(alphafi_sdk_1.cetusPoolMap["ALPHA-USDC"]),
                        txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                        txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-WBTC-USDC") {
                txb.moveCall({
                    target: `${pool.packageId}::alphafi_bluefin_type_1_pool::update_pool_v2`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList["WBTC"].type,
                        alphafi_sdk_1.coinsList["USDC"].type,
                        alphafi_sdk_1.coinsList["BLUE"].type,
                        alphafi_sdk_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_4_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(C.BLUEFIN_WBTC_USDC_POOL),
                        txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                        txb.object(alphafi_sdk_1.cetusPoolMap["USDC-WBTC"]),
                        txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                        txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-NAVX-VSUI") {
                txb.moveCall({
                    target: `${pool.packageId}::alphafi_bluefin_type_2_pool::update_pool_v2`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList["NAVX"].type,
                        alphafi_sdk_1.coinsList["VSUI"].type,
                        alphafi_sdk_1.coinsList["BLUE"].type,
                        alphafi_sdk_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_4_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(C.BLUEFIN_NAVX_VSUI_POOL),
                        txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                        txb.object(alphafi_sdk_1.cetusPoolMap["NAVX-VSUI"]),
                        txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                        txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                        txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-BLUE-SUI") {
                txb.moveCall({
                    target: `${pool.packageId}::alphafi_bluefin_sui_second_pool::update_pool_v2`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList["BLUE"].type,
                        alphafi_sdk_1.coinsList["SUI"].type,
                        alphafi_sdk_1.coinsList["DEEP"].type,
                        alphafi_sdk_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_4_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                        txb.object(C.BLUEFIN_DEEP_SUI_POOL),
                        txb.object(alphafi_sdk_1.cetusPoolMap["BLUE-SUI"]),
                        txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                        txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-BLUE-USDC") {
                txb.moveCall({
                    target: `${pool.packageId}::alphafi_bluefin_type_2_pool::update_pool_v2`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList["BLUE"].type,
                        alphafi_sdk_1.coinsList["USDC"].type,
                        alphafi_sdk_1.coinsList["DEEP"].type,
                        alphafi_sdk_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_4_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(C.BLUEFIN_BLUE_USDC_POOL),
                        txb.object(C.BLUEFIN_DEEP_SUI_POOL),
                        txb.object(alphafi_sdk_1.cetusPoolMap["BLUE-USDC"]),
                        txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                        txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
        }
        else if (pool.parentProtocolName === "BUCKET") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bucket_pool_v1::update_pool`,
                arguments: [
                    txb.object(C.ALPHA_3_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BUCKET_PROTOCOL),
                    txb.object(C.FOUNTAIN),
                    txb.object(C.FLASK),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (pool.parentProtocolName === "NAVI") {
            if (pool.packageNumber === 5) {
                if (key === "NAVI-LOOP-USDT-USDC") {
                    txb.moveCall({
                        target: `${pool.packageId}::alphafi_navi_usdt_usdc_pool::update_pool`,
                        typeArguments: [alphafi_sdk_1.coinsList["NAVX"].type],
                        arguments: [
                            txb.object(C.ALPHA_5_VERSION),
                            txb.object(pool.poolId),
                            txb.object(pool.investorId),
                            txb.object(C.ALPHA_DISTRIBUTOR),
                            txb.object(C.PRICE_ORACLE),
                            txb.object(C.NAVI_STORAGE),
                            txb.object(C.NAVI_USDT_POOL),
                            txb.object(C.NAVI_USDC_POOL),
                            txb.object(C.NAVI_INCENTIVE_V1),
                            txb.object(C.NAVI_INCENTIVE_V2),
                            txb.object(C.NAVI_VSUI_FUNDS_POOL),
                            txb.object(C.NAVI_NAVX_FUNDS_POOL),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap["USDC-USDT"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap["NAVX-SUI"]),
                            txb.object(C.CLOCK_PACKAGE_ID),
                        ],
                    });
                }
            }
            else if (pool.packageNumber === 3) {
                if (key === "NAVI-AUSD" || key === "NAVI-ETH") {
                    txb.moveCall({
                        target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool_with_three_swaps`,
                        typeArguments: [
                            alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                            alphafi_sdk_1.coinsList["USDC"].type,
                            alphafi_sdk_1.coinsList["SUI"].type,
                            alphafi_sdk_1.coinsList["VSUI"].type,
                        ],
                        arguments: [
                            txb.object(C.ALPHA_3_VERSION),
                            txb.object(pool.poolId),
                            txb.object(pool.investorId),
                            txb.object(C.ALPHA_DISTRIBUTOR),
                            txb.object(C.PRICE_ORACLE),
                            txb.object(C.NAVI_STORAGE),
                            txb.object(pool.parentPoolId),
                            txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                            txb.object(C.NAVI_INCENTIVE_V1),
                            txb.object(C.NAVI_INCENTIVE_V2),
                            txb.object(C.NAVI_VSUI_FUNDS_POOL),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap[`USDC-${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}`]),
                            txb.object(C.CLOCK_PACKAGE_ID),
                        ],
                    });
                }
                else if (poolName === "NAVI-NS") {
                    txb.moveCall({
                        target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool_with_two_swaps_v2`,
                        typeArguments: [
                            alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                            alphafi_sdk_1.coinsList["SUI"].type,
                            alphafi_sdk_1.coinsList["VSUI"].type,
                        ],
                        arguments: [
                            txb.object(C.ALPHA_3_VERSION),
                            txb.object(pool.poolId),
                            txb.object(pool.investorId),
                            txb.object(C.ALPHA_DISTRIBUTOR),
                            txb.object(C.PRICE_ORACLE),
                            txb.object(C.NAVI_STORAGE),
                            txb.object(pool.parentPoolId),
                            txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                            txb.object(C.NAVI_INCENTIVE_V1),
                            txb.object(C.NAVI_INCENTIVE_V2),
                            txb.object(C.NAVI_VSUI_FUNDS_POOL),
                            txb.object(C.NAVI_NS_FUNDS_POOL),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap["NS-SUI"]),
                            txb.object(C.CLOCK_PACKAGE_ID),
                        ],
                    });
                }
                else if (poolName === "NAVI-NAVX") {
                    txb.moveCall({
                        target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool_with_two_swaps_v2`,
                        typeArguments: [
                            alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                            alphafi_sdk_1.coinsList["SUI"].type,
                            alphafi_sdk_1.coinsList["VSUI"].type,
                        ],
                        arguments: [
                            txb.object(C.ALPHA_3_VERSION),
                            txb.object(pool.poolId),
                            txb.object(pool.investorId),
                            txb.object(C.ALPHA_DISTRIBUTOR),
                            txb.object(C.PRICE_ORACLE),
                            txb.object(C.NAVI_STORAGE),
                            txb.object(pool.parentPoolId),
                            txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                            txb.object(C.NAVI_INCENTIVE_V1),
                            txb.object(C.NAVI_INCENTIVE_V2),
                            txb.object(C.NAVI_VSUI_FUNDS_POOL),
                            txb.object(C.NAVI_NAVX_FUNDS_POOL),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap["NAVX-SUI"]),
                            txb.object(C.CLOCK_PACKAGE_ID),
                        ],
                    });
                }
            }
            else if (pool.packageNumber === 2) {
                if (key === "NAVI-LOOP-SUI-VSUI") {
                    txb.moveCall({
                        target: `${pool.packageId}::alphafi_navi_sui_vsui_pool::update_pool`,
                        typeArguments: [alphafi_sdk_1.coinsList["NAVX"].type],
                        arguments: [
                            txb.object(C.ALPHA_2_VERSION),
                            txb.object(pool.poolId),
                            txb.object(pool.investorId),
                            txb.object(C.ALPHA_DISTRIBUTOR),
                            txb.object(C.PRICE_ORACLE),
                            txb.object(C.NAVI_STORAGE),
                            txb.object(pool.parentPoolId),
                            txb.object(C.NAVI_SUI_POOL),
                            txb.object(C.NAVI_INCENTIVE_V1),
                            txb.object(C.NAVI_INCENTIVE_V2),
                            txb.object(C.NAVI_NAVX_FUNDS_POOL),
                            txb.object(C.NAVI_VSUI_FUNDS_POOL),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            txb.object(alphafi_sdk_1.cetusPoolMap["NAVX-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                            txb.object(C.VOLO_NATIVE_POOL),
                            txb.object(C.VOLO_METADATA),
                            txb.object(C.SUI_SYSTEM_STATE),
                            txb.object(C.KRIYA_VSUI_SUI_POOL),
                            txb.object(C.KRIYA_VERSION),
                            txb.object(C.CLOCK_PACKAGE_ID),
                        ],
                    });
                }
                else if (key === "NAVI-LOOP-USDC-USDT") {
                    txb.moveCall({
                        target: `${pool.packageId}::alphafi_navi_native_usdc_usdt_pool::update_pool`,
                        arguments: [
                            txb.object(C.ALPHA_2_VERSION),
                            txb.object(pool.poolId),
                            txb.object(pool.investorId),
                            txb.object(C.ALPHA_DISTRIBUTOR),
                            txb.object(C.PRICE_ORACLE),
                            txb.object(C.NAVI_STORAGE),
                            txb.object(C.NAVI_USDC_POOL),
                            txb.object(C.NAVI_USDT_POOL),
                            txb.object(C.NAVI_INCENTIVE_V1),
                            txb.object(C.NAVI_INCENTIVE_V2),
                            txb.object(C.NAVI_VSUI_FUNDS_POOL),
                            txb.object(C.NAVI_NAVX_FUNDS_POOL),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap["NAVX-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap["USDC-USDT"]),
                            txb.object(C.CLOCK_PACKAGE_ID),
                        ],
                    });
                }
                else if (key === "NAVI-LOOP-HASUI-SUI") {
                    txb.moveCall({
                        target: `${pool.packageId}::alphafi_navi_hasui_sui_pool::update_pool`, // change package id for testing
                        typeArguments: [C.NAVX_COIN_TYPE],
                        arguments: [
                            txb.object(C.ALPHA_2_VERSION), // change version object id for testing
                            txb.object(pool.poolId),
                            txb.object(pool.investorId),
                            txb.object(C.ALPHA_DISTRIBUTOR),
                            txb.object(C.PRICE_ORACLE),
                            txb.object(C.NAVI_STORAGE),
                            txb.object(C.NAVI_HASUI_POOL),
                            txb.object(C.NAVI_SUI_POOL),
                            txb.object(C.NAVI_INCENTIVE_V1),
                            txb.object(C.NAVI_INCENTIVE_V2),
                            txb.object(C.NAVI_NAVX_FUNDS_POOL),
                            txb.object(C.NAVI_VSUI_FUNDS_POOL),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            txb.object(alphafi_sdk_1.cetusPoolMap["NAVX-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap["HASUI-SUI"]),
                            txb.object(C.HAEDEL_STAKING),
                            txb.object(C.SUI_SYSTEM_STATE),
                            txb.object(C.CLOCK_PACKAGE_ID),
                        ],
                    });
                }
            }
            else {
                if (poolName === "NAVI-SUI") {
                    txb.moveCall({
                        target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::update_pool_one_swap`,
                        typeArguments: [
                            alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                            alphafi_sdk_1.coinsList["VSUI"].type,
                        ],
                        arguments: [
                            txb.object(C.VERSION),
                            txb.object(pool.poolId),
                            txb.object(pool.investorId),
                            txb.object(C.ALPHA_DISTRIBUTOR),
                            txb.object(C.PRICE_ORACLE),
                            txb.object(C.NAVI_STORAGE),
                            txb.object(pool.parentPoolId),
                            txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                            txb.object(C.NAVI_INCENTIVE_V1),
                            txb.object(C.NAVI_INCENTIVE_V2),
                            txb.object(C.NAVI_VSUI_FUNDS_POOL),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                            txb.object(C.CLOCK_PACKAGE_ID),
                        ],
                    });
                }
                else if (poolName === "NAVI-USDT" ||
                    poolName === "NAVI-WETH" ||
                    poolName === "NAVI-USDY") {
                    txb.moveCall({
                        target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::update_pool_with_three_swaps`,
                        typeArguments: [
                            alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                            alphafi_sdk_1.coinsList["WUSDC"].type,
                            alphafi_sdk_1.coinsList["SUI"].type,
                            alphafi_sdk_1.coinsList["VSUI"].type,
                        ],
                        arguments: [
                            txb.object(C.VERSION),
                            txb.object(pool.poolId),
                            txb.object(pool.investorId),
                            txb.object(C.ALPHA_DISTRIBUTOR),
                            txb.object(C.PRICE_ORACLE),
                            txb.object(C.NAVI_STORAGE),
                            txb.object(pool.parentPoolId),
                            txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                            txb.object(C.NAVI_INCENTIVE_V1),
                            txb.object(C.NAVI_INCENTIVE_V2),
                            txb.object(C.NAVI_VSUI_FUNDS_POOL),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap["WUSDC-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-WUSDC`]),
                            txb.object(C.CLOCK_PACKAGE_ID),
                        ],
                    });
                }
                else if (poolName === "NAVI-VSUI") {
                    txb.moveCall({
                        target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::update_pool_with_two_swaps`,
                        typeArguments: [
                            alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                            alphafi_sdk_1.coinsList["SUI"].type,
                            alphafi_sdk_1.coinsList["NAVX"].type,
                        ],
                        arguments: [
                            txb.object(C.VERSION),
                            txb.object(pool.poolId),
                            txb.object(pool.investorId),
                            txb.object(C.ALPHA_DISTRIBUTOR),
                            txb.object(C.PRICE_ORACLE),
                            txb.object(C.NAVI_STORAGE),
                            txb.object(pool.parentPoolId),
                            txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                            txb.object(C.NAVI_INCENTIVE_V1),
                            txb.object(C.NAVI_INCENTIVE_V2),
                            txb.object(C.NAVI_NAVX_FUNDS_POOL),
                            txb.object(C.NAVI_VSUI_FUNDS_POOL),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            txb.object(alphafi_sdk_1.cetusPoolMap["NAVX-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                            txb.object(C.CLOCK_PACKAGE_ID),
                        ],
                    });
                }
                else if (poolName === "NAVI-WUSDC") {
                    txb.moveCall({
                        target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::update_pool_with_three_swaps`,
                        typeArguments: [
                            alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                            alphafi_sdk_1.coinsList["CETUS"].type,
                            alphafi_sdk_1.coinsList["SUI"].type,
                            alphafi_sdk_1.coinsList["VSUI"].type,
                        ],
                        arguments: [
                            txb.object(C.VERSION),
                            txb.object(pool.poolId),
                            txb.object(pool.investorId),
                            txb.object(C.ALPHA_DISTRIBUTOR),
                            txb.object(C.PRICE_ORACLE),
                            txb.object(C.NAVI_STORAGE),
                            txb.object(pool.parentPoolId),
                            txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                            txb.object(C.NAVI_INCENTIVE_V1),
                            txb.object(C.NAVI_INCENTIVE_V2),
                            txb.object(C.NAVI_VSUI_FUNDS_POOL),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap["CETUS-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-CETUS`]),
                            txb.object(C.CLOCK_PACKAGE_ID),
                        ],
                    });
                }
                else if (poolName === "NAVI-USDC") {
                    txb.moveCall({
                        target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::update_pool_with_three_swaps`,
                        typeArguments: [
                            alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                            alphafi_sdk_1.coinsList["BUCK"].type,
                            alphafi_sdk_1.coinsList["SUI"].type,
                            alphafi_sdk_1.coinsList["VSUI"].type,
                        ],
                        arguments: [
                            txb.object(C.VERSION),
                            txb.object(pool.poolId),
                            txb.object(pool.investorId),
                            txb.object(C.ALPHA_DISTRIBUTOR),
                            txb.object(C.PRICE_ORACLE),
                            txb.object(C.NAVI_STORAGE),
                            txb.object(pool.parentPoolId),
                            txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                            txb.object(C.NAVI_INCENTIVE_V1),
                            txb.object(C.NAVI_INCENTIVE_V2),
                            txb.object(C.NAVI_VSUI_FUNDS_POOL),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap["BUCK-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-BUCK`]),
                            txb.object(C.CLOCK_PACKAGE_ID),
                        ],
                    });
                }
                else {
                    txb.moveCall({
                        target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::update_pool_with_two_swaps`,
                        typeArguments: [
                            alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                            alphafi_sdk_1.coinsList["SUI"].type,
                            alphafi_sdk_1.coinsList["VSUI"].type,
                        ],
                        arguments: [
                            txb.object(C.VERSION),
                            txb.object(pool.poolId),
                            txb.object(pool.investorId),
                            txb.object(C.ALPHA_DISTRIBUTOR),
                            txb.object(C.PRICE_ORACLE),
                            txb.object(C.NAVI_STORAGE),
                            txb.object(pool.parentPoolId),
                            txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                            txb.object(C.NAVI_INCENTIVE_V1),
                            txb.object(C.NAVI_INCENTIVE_V2),
                            txb.object(C.NAVI_NAVX_FUNDS_POOL),
                            txb.object(C.NAVI_VSUI_FUNDS_POOL),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                            txb.object(C.CLOCK_PACKAGE_ID),
                        ],
                    });
                }
            }
        }
        else {
            if (pool.packageNumber === 2) {
                txb.moveCall({
                    target: `${pool.packageId}::alphafi_cetus_sui_pool::update_pool`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                        alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_2_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(C.CETUS_REWARDER_GLOBAL_VAULT_ID),
                        txb.object(alphafi_sdk_1.cetusPoolMap[poolName]),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else {
                if (poolName === "ALPHA") {
                    const type = C.ALPHA_COIN_TYPE;
                    txb.moveCall({
                        target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphapool::get_pool_rewards_all`,
                        typeArguments: [type],
                        arguments: [
                            txb.object(C.VERSION),
                            txb.object(pool.poolId),
                            txb.object(C.ALPHA_DISTRIBUTOR),
                            txb.object(C.CLOCK_PACKAGE_ID),
                        ],
                    });
                }
                else if (poolName !== "HASUI-SUI") {
                    const coinAName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1;
                    const coinA = alphafi_sdk_1.coinsList[coinAName];
                    const coinBName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2;
                    const coinB = alphafi_sdk_1.coinsList[coinBName];
                    if (coinBName === "SUI") {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_cetus_sui_pool::update_pool`,
                            typeArguments: [coinA.type, coinB.type],
                            arguments: [
                                txb.object(C.VERSION),
                                txb.object(pool.poolId),
                                txb.object(pool.investorId),
                                txb.object(C.ALPHA_DISTRIBUTOR),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                txb.object(C.CETUS_REWARDER_GLOBAL_VAULT_ID),
                                txb.object(alphafi_sdk_1.cetusPoolMap["CETUS-SUI"]),
                                txb.object(alphafi_sdk_1.cetusPoolMap[poolName]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (poolName === "WUSDC-WBTC" ||
                        poolName === "USDC-USDT" ||
                        poolName === "USDC-WUSDC" ||
                        poolName === "USDC-ETH") {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_cetus_pool_base_a::update_pool`,
                            typeArguments: [coinA.type, coinB.type],
                            arguments: [
                                txb.object(C.VERSION),
                                txb.object(pool.poolId),
                                txb.object(pool.investorId),
                                txb.object(C.ALPHA_DISTRIBUTOR),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                txb.object(C.CETUS_REWARDER_GLOBAL_VAULT_ID),
                                txb.object(alphafi_sdk_1.cetusPoolMap[`${coinAName}-SUI`]),
                                txb.object(alphafi_sdk_1.cetusPoolMap["CETUS-SUI"]),
                                txb.object(alphafi_sdk_1.cetusPoolMap[poolName]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_cetus_pool::update_pool`,
                            typeArguments: [coinA.type, coinB.type],
                            arguments: [
                                txb.object(C.VERSION),
                                txb.object(pool.poolId),
                                txb.object(pool.investorId),
                                txb.object(C.ALPHA_DISTRIBUTOR),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                txb.object(C.CETUS_REWARDER_GLOBAL_VAULT_ID),
                                txb.object(alphafi_sdk_1.cetusPoolMap[`${coinBName}-SUI`]),
                                txb.object(alphafi_sdk_1.cetusPoolMap["CETUS-SUI"]),
                                txb.object(alphafi_sdk_1.cetusPoolMap[poolName]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                }
            }
        }
    });
    return txb;
}
async function getDoubleAssetAutoCompoundTxb() {
    let txb = new transactions_1.Transaction();
    const C = (0, alphafi_sdk_1.getConf)();
    const poolNames = Object.keys(alphafi_sdk_1.poolInfo)
        .map((key) => {
        const poolName = key;
        if ((alphafi_sdk_1.poolInfo[poolName] &&
            !["CETUS", "BLUEFIN"].includes(alphafi_sdk_1.poolInfo[poolName].parentProtocolName)) ||
            alphafi_sdk_1.poolInfo[key].poolId == "" ||
            poolName === "BLUEFIN-NAVX-VSUI") {
            return;
        }
        return key;
    })
        .filter((key) => key !== undefined);
    const autocompoundRequired = await getAutocompoundRequired(poolNames);
    for (const key of autocompoundRequired) {
        const poolName = key;
        const tx = await getAutoCompoundSingleTxb(poolName, txb);
        if (tx) {
            txb = tx;
        }
    }
    return txb;
}
const groupedRewards = async (pools) => {
    const res = new Map();
    for (const ele of pools) {
        if (alphafi_sdk_1.poolInfo[ele].parentProtocolName === "NAVI") {
            res.set(ele, await getAvailableRewards(alphafi_sdk_1.loopingAccountAddresses[ele]));
        }
    }
    return res;
};
exports.groupedRewards = groupedRewards;
async function getSingleAssetOneAutoCompoundTxb() {
    let txb = new transactions_1.Transaction();
    const C = (0, alphafi_sdk_1.getConf)();
    const poolNames = Object.keys(alphafi_sdk_1.poolInfo)
        .map((key) => {
        const poolName = key;
        if ((alphafi_sdk_1.poolInfo[poolName] &&
            !["NAVI", "BUCKET", "ALPHAFI"].includes(alphafi_sdk_1.poolInfo[poolName].parentProtocolName)) ||
            alphafi_sdk_1.poolInfo[key].poolId == "" ||
            poolName.toString().includes("LOOP") ||
            [
                "NAVI-USDC",
                "NAVI-WUSDC",
                "NAVI-USDT",
                "NAVI-ETH",
                "NAVI-WETH",
                // "BUCKET-BUCK",
                // "NAVI-SUIBTC",
            ].includes(poolName) ||
            alphafi_sdk_1.poolInfo[key].retired === true) {
            return;
        }
        return key;
    })
        .filter((key) => key !== undefined);
    const autocompoundRequired = await getAutocompoundRequired(poolNames);
    const gr = await (0, exports.groupedRewards)(autocompoundRequired);
    autocompoundRequired.forEach(async (key) => {
        const poolName = key;
        console.log("One", "poolName", poolName);
        const pool = alphafi_sdk_1.poolInfo[key];
        const tx = await getAutoCompoundSingleTxb(poolName, txb, gr);
        if (tx) {
            txb = tx;
        }
    });
    return txb;
}
async function getSingleAssetTwoAutoCompoundTxb() {
    let txb = new transactions_1.Transaction();
    const C = (0, alphafi_sdk_1.getConf)();
    const poolNames = Object.keys(alphafi_sdk_1.poolInfo)
        .map((key) => {
        const poolName = key;
        if ((alphafi_sdk_1.poolInfo[poolName] &&
            !["NAVI", "BUCKET", "ALPHAFI"].includes(alphafi_sdk_1.poolInfo[poolName].parentProtocolName)) ||
            alphafi_sdk_1.poolInfo[key].poolId == "" ||
            poolName.toString().includes("LOOP") ||
            !["NAVI-USDC", "NAVI-WUSDC", "NAVI-USDT", "NAVI-ETH"].includes(poolName) ||
            alphafi_sdk_1.poolInfo[key].retired === true) {
            return;
        }
        return key;
    })
        .filter((key) => key !== undefined);
    const autocompoundRequired = await getAutocompoundRequired(poolNames);
    const gr = await (0, exports.groupedRewards)(autocompoundRequired);
    autocompoundRequired.forEach(async (key) => {
        const poolName = key;
        console.log("Two", "poolName", poolName);
        const tx = await getAutoCompoundSingleTxb(poolName, txb, gr);
        if (tx) {
            txb = tx;
        }
    });
    return txb;
}
const alphalendClient = new alphalend_sdk_1.AlphalendClient("mainnet", (0, alphafi_sdk_1.getSuiClient)());
async function getLoopingPoolsAutoCompoundTxb() {
    let txb = new transactions_1.Transaction();
    const C = (0, alphafi_sdk_1.getConf)();
    const poolNames = Object.keys(alphafi_sdk_1.poolInfo)
        .map((key) => {
        const poolName = key;
        if (!poolName.toString().includes("LOOP")) {
            return;
        }
        return key;
    })
        .filter((key) => key !== undefined);
    const autocompoundRequired = await getAutocompoundRequired(poolNames);
    const gr = await (0, exports.groupedRewards)(autocompoundRequired);
    let typeList = [];
    for (const x of autocompoundRequired) {
        if (alphafi_sdk_1.poolInfo[x].parentProtocolName === "ALPHALEND") {
            typeList.push(alphafi_sdk_1.coinsList[alphafi_sdk_1.loopingPoolCoinMap[x].supplyCoin].type);
            typeList.push(alphafi_sdk_1.coinsList[alphafi_sdk_1.loopingPoolCoinMap[x].borrowCoin].type);
        }
    }
    typeList = typeList.filter((type) => type !== alphafi_sdk_1.coinsList["SUI"].type);
    typeList.push("0x2::sui::SUI");
    await alphalendClient.updatePrices(txb, [...new Set(typeList)]);
    autocompoundRequired.forEach(async (key) => {
        const poolName = key;
        const tx = await getAutoCompoundSingleTxb(poolName, txb, gr);
        if (tx) {
            txb = tx;
        }
    });
    return txb;
}
async function getAutoCompoundSingleTxb(poolName, tx, groupedRewards) {
    let txb = new transactions_1.Transaction();
    if (tx) {
        txb = tx;
    }
    const C = (0, alphafi_sdk_1.getConf)();
    const pool = alphafi_sdk_1.poolInfo[poolName];
    if (!pool || !pool.poolId) {
        console.log(`Pool does not exit yet: ${poolName}`);
        return;
    }
    if (pool.parentProtocolName === "BLUEFIN") {
        const coin1 = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1;
        const coin2 = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2;
        if (pool.strategyType === "AUTOBALANCE-LIQUIDITY-POOL") {
            await (0, alphafi_sdk_1.collectRewardTxb)(poolName, true, txb);
        }
        else if (pool.strategyType === "LEVERAGE-YIELD-FARMING") {
            const coinAType = coin1 === "SUI" ? "0x2::sui::SUI" : alphafi_sdk_1.coinsList[coin1].type;
            const coinBType = coin2 === "SUI" ? "0x2::sui::SUI" : alphafi_sdk_1.coinsList[coin2].type;
            await alphalendClient.updatePrices(txb, [coinAType, coinBType]);
            await (0, alphafi_sdk_1.collectAndSwapRewardsLyf)(poolName, txb);
            txb.moveCall({
                target: `${pool.packageId}::alphafi_lyf_pool::update_pool`,
                typeArguments: [alphafi_sdk_1.coinsList[coin1].type, alphafi_sdk_1.coinsList[coin2].type],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_LYF_VERSION),
                    txb.object(pool.poolId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().LENDING_PROTOCOL_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(pool.parentPoolId),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        if (poolName === "BLUEFIN-SUI-USDC") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_sui_first_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(C.BLUEFIN_SUI_USDC_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-SUI-BUCK") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_sui_first_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["BUCK"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(C.BLUEFIN_SUI_BUCK_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["BUCK-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-USDT-USDC") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                typeArguments: [
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.BLUEFIN_USDT_USDC_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_type_1_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["USDT"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(C.BLUEFIN_USDT_USDC_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-USDT"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-AUSD-USDC") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                typeArguments: [
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.BLUEFIN_AUSD_USDC_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_type_1_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["AUSD"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(C.BLUEFIN_AUSD_USDC_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-AUSD"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-SUI-AUSD") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_sui_first_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["AUSD"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(C.BLUEFIN_SUI_AUSD_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["AUSD-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-ALPHA-USDC") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_type_2_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["ALPHA"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(C.BLUEFIN_ALPHA_USDC_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["ALPHA-USDC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-WBTC-USDC") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                typeArguments: [
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.BLUEFIN_WBTC_USDC_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_type_1_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["WBTC"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(C.BLUEFIN_WBTC_USDC_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-WBTC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-NAVX-VSUI") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_type_2_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["NAVX"].type,
                    alphafi_sdk_1.coinsList["VSUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(C.BLUEFIN_NAVX_VSUI_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["NAVX-VSUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-BLUE-SUI") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_sui_second_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["DEEP"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(C.BLUEFIN_DEEP_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["BLUE-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-BLUE-USDC") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_type_2_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["DEEP"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(C.BLUEFIN_BLUE_USDC_POOL),
                    txb.object(C.BLUEFIN_DEEP_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["BLUE-USDC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-SEND-USDC") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                typeArguments: [
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.BLUEFIN_SEND_USDC_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_type_1_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SEND"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(C.BLUEFIN_SEND_USDC_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SEND"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-WBTC-SUI") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_sui_second_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["WBTC"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(C.BLUEFIN_WBTC_SUI_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["WBTC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-DEEP-SUI") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_sui_second_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["DEEP"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(C.BLUEFIN_DEEP_SUI_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["DEEP-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-STSUI-SUI") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_stsui_sui_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(pool.parentPoolId),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(C.LST_INFO),
                    txb.object(C.SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-STSUI-USDC") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_stsui_first_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_STSUI_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_STSUI_USDC_ZERO_ONE_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(true),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-ALPHA-STSUI") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_stsui_second_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["ALPHA"].type,
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_STSUI_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_ALPHA_STSUI_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["ALPHA-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-ALPHA"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(true),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (alphafi_sdk_1.AUTOBALANCE_TYPE_1_POOLS.includes(poolName)) {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_type_1_pool::update_pool_v3`,
                typeArguments: [alphafi_sdk_1.coinsList[coin1].type, alphafi_sdk_1.coinsList[coin2].type],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(pool.parentPoolId),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-SUIUSDT-USDC") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                typeArguments: [
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.BLUEFIN_SUIUSDT_USDC_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_type_1_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SUIUSDT"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(C.BLUEFIN_SUIUSDT_USDC_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUIUSDT"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (alphafi_sdk_1.AUTOBALANCE_SUI_SECOND_POOLS.includes(poolName)) {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_sui_second_pool::update_pool_v3`,
                typeArguments: [alphafi_sdk_1.coinsList[coin1].type, alphafi_sdk_1.coinsList[coin2].type],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(pool.parentPoolId),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-STSUI-WSOL") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_stsui_first_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["WSOL"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_STSUI_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_STSUI_WSOL_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["WSOL-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-WSOL"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(true),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-STSUI-ETH") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_stsui_first_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["ETH"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_STSUI_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_STSUI_ETH_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["ETH-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-ETH"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(true),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-STSUI-BUCK") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_stsui_first_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["BUCK"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_STSUI_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_STSUI_BUCK_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["BUCK-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-BUCK"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(true),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-STSUI-MUSD") {
            // ignore STSUI-MUSD from autocompound
            // txb.moveCall({
            //   target: `${pool.packageId}::alphafi_bluefin_stsui_first_pool::update_pool`,
            //   typeArguments: [
            //     coinsList["STSUI"].type,
            //     coinsList["MUSD"].type,
            //     coinsList["BLUE"].type,
            //   ],
            //   arguments: [
            //     txb.object(C.ALPHA_STSUI_VERSION),
            //     txb.object(pool.poolId),
            //     txb.object(pool.investorId),
            //     txb.object(C.ALPHA_DISTRIBUTOR),
            //     txb.object(C.BLUEFIN_GLOBAL_CONFIG),
            //     txb.object(C.CETUS_GLOBAL_CONFIG_ID),
            //     txb.object(getConf().BLUEFIN_STSUI_MUSD_POOL),
            //     txb.object(getConf().BLUEFIN_BLUE_SUI_POOL),
            //     txb.object(cetusPoolMap["MUSD-SUI"]),
            //     txb.object(bluefinPoolMap["SUI-MUSD"]),
            //     txb.object(getConf().LST_INFO),
            //     txb.object(getConf().SUI_SYSTEM_STATE),
            //     txb.pure.bool(true),
            //     txb.object(C.CLOCK_PACKAGE_ID),
            //   ],
            // });
        }
        else if (poolName === "BLUEFIN-FUNGIBLE-STSUI-SUI") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_stsui_sui_ft_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    pool.receiptType,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_FUNGIBLE_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_STSUI_SUI_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-SUIBTC-USDC") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                typeArguments: [
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["DEEP"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_BLUEFIN_V2_VERSION),
                    txb.object(pool.investorId),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.BLUEFIN_SUIBTC_USDC_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(C.BLUEFIN_DEEP_SUI_POOL),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_type_1_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SUIBTC"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["DEEP"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_BLUEFIN_V2_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(C.BLUEFIN_SUIBTC_USDC_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(C.BLUEFIN_DEEP_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUIBTC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (alphafi_sdk_1.AUTOBALANCE_SUI_FIRST_POOLS.includes(poolName)) {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_sui_first_pool::update_pool_v4`,
                typeArguments: [alphafi_sdk_1.coinsList[coin1].type, alphafi_sdk_1.coinsList[coin2].type],
                arguments: [
                    txb.object(C.ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(pool.parentPoolId),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-LBTC-SUIBTC") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                typeArguments: [
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["DEEP"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_BLUEFIN_V2_VERSION),
                    txb.object(pool.investorId),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.BLUEFIN_LBTC_SUIBTC_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(C.BLUEFIN_DEEP_SUI_POOL),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-SUIBTC"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_type_1_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["LBTC"].type,
                    alphafi_sdk_1.coinsList["SUIBTC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["DEEP"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_BLUEFIN_V2_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(C.BLUEFIN_LBTC_SUIBTC_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(C.BLUEFIN_DEEP_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["SUIBTC-LBTC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["SUIBTC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-WAL-STSUI") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_stsui_second_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["WAL"].type,
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_STSUI_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_WAL_STSUI_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["WAL-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-WAL"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(true),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-WAL-USDC") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                typeArguments: [
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.BLUEFIN_WAL_USDC_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_type_1_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["WAL"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_4_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(C.BLUEFIN_WAL_USDC_POOL),
                    txb.object(C.BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-WAL"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
    }
    else if (pool.parentProtocolName === "BUCKET") {
        txb.moveCall({
            target: `${pool.packageId}::alphafi_bucket_investor_v1::collect_and_convert_reward_to_buck`,
            arguments: [
                txb.object(C.ALPHA_3_VERSION),
                txb.object(pool.investorId),
                txb.object(C.BUCKET_PROTOCOL),
                txb.object(C.FOUNTAIN),
                txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
        txb.moveCall({
            target: `${pool.packageId}::alphafi_bucket_pool_v1::update_pool`,
            arguments: [
                txb.object(C.ALPHA_3_VERSION),
                txb.object(pool.poolId),
                txb.object(pool.investorId),
                txb.object(C.ALPHA_DISTRIBUTOR),
                txb.object(C.BUCKET_PROTOCOL),
                txb.object(C.FOUNTAIN),
                txb.object(C.FLASK),
                txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
    }
    else if (pool.parentProtocolName === "ALPHALEND") {
        if (pool.strategyType === "LOOPING") {
            const supplyCoinType = alphafi_sdk_1.coinsList[alphafi_sdk_1.loopingPoolCoinMap[poolName].supplyCoin].type;
            const borrowCoinType = alphafi_sdk_1.loopingPoolCoinMap[poolName].borrowCoin === "SUI"
                ? "0x2::sui::SUI"
                : alphafi_sdk_1.coinsList[alphafi_sdk_1.loopingPoolCoinMap[poolName].borrowCoin].type;
            await alphalendClient.updatePrices(txb, [supplyCoinType, borrowCoinType]);
        }
        else if (pool.strategyType === "SINGLE-LOOPING") {
            const supplyCoinType = alphafi_sdk_1.coinsList[alphafi_sdk_1.loopingPoolCoinMap[poolName].supplyCoin].type;
            await alphalendClient.updatePrices(txb, [supplyCoinType]);
            await (0, alphafi_sdk_1.collectAndSwapRewardsSingleLoop)(poolName, txb);
            txb.moveCall({
                target: `${pool.packageId}::alphafi_alphalend_single_loop_pool::update_pool`,
                typeArguments: [supplyCoinType],
                arguments: [
                    txb.object(C.ALPHA_ALPHALEND_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.LENDING_PROTOCOL_ID),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        if (poolName === "ALPHALEND-LOOP-SUI-STSUI") {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_navi_sui_stsui_pool::collect_v3_rewards_with_one_swap`,
                typeArguments: [alphafi_sdk_1.coinsList["ALPHA"].type],
                arguments: [
                    txb.object(C.ALPHA_5_VERSION),
                    txb.object(pool.investorId),
                    txb.object(C.LENDING_PROTOCOL_ID),
                    txb.object(alphafi_sdk_1.bluefinPoolMap[`ALPHA-STSUI`]),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${pool.packageId}::alphafi_navi_sui_stsui_pool::collect_v3_rewards_with_no_swap_v2`,
                arguments: [
                    txb.object(C.ALPHA_5_VERSION),
                    txb.object(pool.investorId),
                    txb.object(C.LENDING_PROTOCOL_ID),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${pool.packageId}::alphafi_navi_sui_stsui_pool::collect_v3_rewards_with_two_swaps_v2`,
                typeArguments: [alphafi_sdk_1.coinsList["BLUE"].type],
                arguments: [
                    txb.object(C.ALPHA_5_VERSION),
                    txb.object(pool.investorId),
                    txb.object(C.LENDING_PROTOCOL_ID),
                    txb.object(C.LST_INFO),
                    txb.object(C.SUI_SYSTEM_STATE),
                    txb.object(alphafi_sdk_1.cetusPoolMap[`BLUE-SUI`]),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${pool.packageId}::alphafi_navi_sui_stsui_pool::update_pool_v3`,
                arguments: [
                    txb.object(C.ALPHA_5_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.LENDING_PROTOCOL_ID),
                    txb.object(C.LST_INFO),
                    txb.object(C.SUI_SYSTEM_STATE),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
    }
    else if (pool.parentProtocolName === "NAVI") {
        if (pool.packageNumber === 9) {
            if (poolName === "NAVI-SUIBTC") {
                const claimableRewards = groupedRewards?.get(poolName);
                if (claimableRewards) {
                    for (const reward of claimableRewards.get(alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type) || []) {
                        if (reward.rewardCoinType === alphafi_sdk_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["SUI"].type,
                                    alphafi_sdk_1.coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_NAVI_V2_VERSION),
                                    txb.object(pool.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                    txb.object(alphafi_sdk_1.bluefinPoolMap["NAVX-SUI"]),
                                    txb.object(alphafi_sdk_1.bluefinPoolMap[`SUI-${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["DEEP"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["SUI"].type,
                                    alphafi_sdk_1.coinsList["DEEP"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_NAVI_V2_VERSION),
                                    txb.object(pool.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_DEEP_REWARDS_POOL),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                    txb.object(alphafi_sdk_1.bluefinPoolMap["DEEP-SUI"]),
                                    txb.object(alphafi_sdk_1.bluefinPoolMap[`SUI-${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["SUI"].type,
                                    alphafi_sdk_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_NAVI_V2_VERSION),
                                    txb.object(pool.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                    txb.object(alphafi_sdk_1.bluefinPoolMap["VSUI-SUI"]),
                                    txb.object(alphafi_sdk_1.bluefinPoolMap[`SUI-${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool_v2`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_NAVI_V2_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(pool.parentPoolId),
                        txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
        }
        else if (pool.packageNumber === 5) {
            if (poolName === "NAVI-LOOP-USDT-USDC") {
                const claimableRewards = groupedRewards?.get(poolName);
                const rewardCoinSet = new Set();
                if (claimableRewards) {
                    for (const reward of claimableRewards.get(alphafi_sdk_1.coinsList[alphafi_sdk_1.loopingPoolCoinMap[poolName].supplyCoin].type) || []) {
                        if (rewardCoinSet.has(reward.rewardCoinType) === false) {
                            if (reward.rewardCoinType === alphafi_sdk_1.coinsList["NAVX"].type) {
                                txb.moveCall({
                                    target: `${pool.packageId}::alphafi_navi_usdt_usdc_investor::collect_v3_rewards_with_three_swaps`,
                                    typeArguments: [
                                        alphafi_sdk_1.coinsList["USDT"].type,
                                        alphafi_sdk_1.coinsList["USDC"].type,
                                        alphafi_sdk_1.coinsList["SUI"].type,
                                        reward.rewardCoinType,
                                    ],
                                    arguments: [
                                        txb.object(pool.investorId),
                                        txb.object(C.ALPHA_5_VERSION),
                                        txb.object(C.CLOCK_PACKAGE_ID),
                                        txb.object(C.NAVI_STORAGE),
                                        txb.object(C.NAVI_INCENTIVE_V3),
                                        txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`NAVX-SUI`]),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`USDC-SUI`]),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`USDC-USDT`]),
                                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    ],
                                });
                            }
                            else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["VSUI"].type) {
                                txb.moveCall({
                                    target: `${pool.packageId}::alphafi_navi_usdt_usdc_investor::collect_v3_rewards_with_three_swaps`,
                                    typeArguments: [
                                        alphafi_sdk_1.coinsList["USDT"].type,
                                        alphafi_sdk_1.coinsList["USDC"].type,
                                        alphafi_sdk_1.coinsList["SUI"].type,
                                        reward.rewardCoinType,
                                    ],
                                    arguments: [
                                        txb.object(pool.investorId),
                                        txb.object(C.ALPHA_5_VERSION),
                                        txb.object(C.CLOCK_PACKAGE_ID),
                                        txb.object(C.NAVI_STORAGE),
                                        txb.object(C.NAVI_INCENTIVE_V3),
                                        txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`VSUI-SUI`]),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`USDC-SUI`]),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`USDC-USDT`]),
                                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    ],
                                });
                            }
                            rewardCoinSet.add(reward.rewardCoinType);
                        }
                    }
                    for (const reward of claimableRewards.get(alphafi_sdk_1.coinsList[alphafi_sdk_1.loopingPoolCoinMap[poolName].borrowCoin].type) || []) {
                        if (rewardCoinSet.has(reward.rewardCoinType) === false) {
                            if (reward.rewardCoinType === alphafi_sdk_1.coinsList["NAVX"].type) {
                                txb.moveCall({
                                    target: `${pool.packageId}::alphafi_navi_usdt_usdc_investor::collect_v3_rewards_with_three_swaps`,
                                    typeArguments: [
                                        alphafi_sdk_1.coinsList["USDT"].type,
                                        alphafi_sdk_1.coinsList["USDC"].type,
                                        alphafi_sdk_1.coinsList["SUI"].type,
                                        reward.rewardCoinType,
                                    ],
                                    arguments: [
                                        txb.object(pool.investorId),
                                        txb.object(C.ALPHA_5_VERSION),
                                        txb.object(C.CLOCK_PACKAGE_ID),
                                        txb.object(C.NAVI_STORAGE),
                                        txb.object(C.NAVI_INCENTIVE_V3),
                                        txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`NAVX-SUI`]),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`USDC-SUI`]),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`USDC-USDT`]),
                                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    ],
                                });
                            }
                            else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["VSUI"].type) {
                                txb.moveCall({
                                    target: `${pool.packageId}::alphafi_navi_usdt_usdc_investor::collect_v3_rewards_with_three_swaps`,
                                    typeArguments: [
                                        alphafi_sdk_1.coinsList["USDT"].type,
                                        alphafi_sdk_1.coinsList["USDC"].type,
                                        alphafi_sdk_1.coinsList["SUI"].type,
                                        reward.rewardCoinType,
                                    ],
                                    arguments: [
                                        txb.object(pool.investorId),
                                        txb.object(C.ALPHA_5_VERSION),
                                        txb.object(C.CLOCK_PACKAGE_ID),
                                        txb.object(C.NAVI_STORAGE),
                                        txb.object(C.NAVI_INCENTIVE_V3),
                                        txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`VSUI-SUI`]),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`USDC-SUI`]),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`USDC-USDT`]),
                                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    ],
                                });
                            }
                            rewardCoinSet.add(reward.rewardCoinType);
                        }
                    }
                }
                txb.moveCall({
                    target: `${pool.packageId}::alphafi_navi_usdt_usdc_pool::update_pool_v2`,
                    arguments: [
                        txb.object(C.ALPHA_5_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(C.NAVI_USDT_POOL),
                        txb.object(C.NAVI_USDC_POOL),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
        }
        else if (pool.packageNumber === 3) {
            if (poolName === "NAVI-AUSD" ||
                poolName === "NAVI-ETH" ||
                poolName === "NAVI-SUIUSDT") {
                const claimableRewards = groupedRewards?.get(poolName);
                if (claimableRewards) {
                    for (const reward of claimableRewards.get(alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type) || []) {
                        if (reward.rewardCoinType === alphafi_sdk_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(pool.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_three_swaps`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["USDC"].type,
                                    alphafi_sdk_1.coinsList["SUI"].type,
                                    alphafi_sdk_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(pool.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                                    txb.object(alphafi_sdk_1.cetusPoolMap[`USDC-${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(pool.parentPoolId),
                        txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "NAVI-NS") {
                const claimableRewards = groupedRewards?.get(poolName);
                if (claimableRewards) {
                    for (const reward of claimableRewards.get(alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type) || []) {
                        if (reward.rewardCoinType === alphafi_sdk_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(pool.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(alphafi_sdk_1.cetusPoolMap["NAVX-SUI"]),
                                    txb.object(alphafi_sdk_1.cetusPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["DEEP"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["DEEP"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(pool.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_DEEP_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(alphafi_sdk_1.cetusPoolMap["DEEP-SUI"]),
                                    txb.object(alphafi_sdk_1.cetusPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["SUI"].type,
                                    alphafi_sdk_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(pool.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                                    txb.object(alphafi_sdk_1.cetusPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["NS"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(pool.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NS_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(pool.parentPoolId),
                        txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "NAVI-NAVX") {
                const claimableRewards = groupedRewards?.get(poolName);
                if (claimableRewards) {
                    for (const reward of claimableRewards.get(alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type) || []) {
                        if (reward.rewardCoinType === alphafi_sdk_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(pool.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["SUI"].type,
                                    alphafi_sdk_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(pool.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                                    txb.object(alphafi_sdk_1.cetusPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(pool.parentPoolId),
                        txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "NAVI-STSUI") {
                const claimableRewards = groupedRewards?.get(poolName);
                if (claimableRewards) {
                    for (const reward of claimableRewards.get(alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type) || []) {
                        if (reward.rewardCoinType === alphafi_sdk_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["SUI"].type,
                                    alphafi_sdk_1.coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(pool.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(alphafi_sdk_1.cetusPoolMap["NAVX-SUI"]),
                                    txb.object(alphafi_sdk_1.cetusPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["SUI"].type,
                                    alphafi_sdk_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(pool.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                                    txb.object(alphafi_sdk_1.cetusPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["STSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(pool.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_STSUI_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(pool.parentPoolId),
                        txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "NAVI-DEEP") {
                const claimableRewards = groupedRewards?.get(poolName);
                if (claimableRewards) {
                    for (const reward of claimableRewards.get(alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type) || []) {
                        if (reward.rewardCoinType === alphafi_sdk_1.coinsList["DEEP"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(pool.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_DEEP_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["SUI"].type,
                                    alphafi_sdk_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(pool.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                    txb.object(alphafi_sdk_1.bluefinPoolMap["VSUI-SUI"]),
                                    txb.object(alphafi_sdk_1.bluefinPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["SUI"].type,
                                    alphafi_sdk_1.coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(pool.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(alphafi_sdk_1.cetusPoolMap["NAVX-SUI"]),
                                    txb.object(alphafi_sdk_1.cetusPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(pool.parentPoolId),
                        txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "NAVI-WAL") {
                const claimableRewards = groupedRewards?.get(poolName);
                if (claimableRewards) {
                    for (const reward of claimableRewards.get(alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type) || [
                        { rewardCoinType: alphafi_sdk_1.coinsList["WAL"].type },
                        { rewardCoinType: alphafi_sdk_1.coinsList["VSUI"].type },
                    ]) {
                        if (reward.rewardCoinType === alphafi_sdk_1.coinsList["WAL"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(pool.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_WAL_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["SUI"].type,
                                    alphafi_sdk_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(pool.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                    txb.object(alphafi_sdk_1.bluefinPoolMap["VSUI-SUI"]),
                                    txb.object(alphafi_sdk_1.bluefinPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(pool.parentPoolId),
                        txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
        }
        else if (pool.packageNumber === 2) {
            if (poolName === "NAVI-LOOP-SUI-VSUI") {
                const claimableRewards = groupedRewards?.get(poolName);
                const rewardCoinSet = new Set();
                if (claimableRewards) {
                    for (const reward of claimableRewards.get(alphafi_sdk_1.coinsList[alphafi_sdk_1.loopingPoolCoinMap[poolName].supplyCoin].type) || []) {
                        if (rewardCoinSet.has(reward.rewardCoinType) === false) {
                            if (reward.rewardCoinType === alphafi_sdk_1.coinsList["NAVX"].type) {
                                rewardCoinSet.add(reward.rewardCoinType);
                                txb.moveCall({
                                    target: `${pool.packageId}::alphafi_navi_sui_vsui_investor::collect_reward_with_two_swaps_v2`,
                                    typeArguments: [alphafi_sdk_1.coinsList["NAVX"].type],
                                    arguments: [
                                        txb.object(pool.investorId),
                                        txb.object(C.ALPHA_2_VERSION),
                                        txb.object(C.CLOCK_PACKAGE_ID),
                                        txb.object(C.NAVI_STORAGE),
                                        txb.object(C.NAVI_INCENTIVE_V3),
                                        txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                        txb.object(C.VOLO_STAKE_POOL),
                                        txb.object(C.VOLO_METADATA),
                                        txb.object(C.SUI_SYSTEM_STATE),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`NAVX-SUI`]),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`VSUI-SUI`]),
                                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    ],
                                });
                            }
                            else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["VSUI"].type) {
                                txb.moveCall({
                                    target: `${pool.packageId}::alphafi_navi_sui_vsui_investor::collect_reward_with_no_swap`,
                                    arguments: [
                                        txb.object(pool.investorId),
                                        txb.object(C.ALPHA_2_VERSION),
                                        txb.object(C.CLOCK_PACKAGE_ID),
                                        txb.object(C.NAVI_STORAGE),
                                        txb.object(C.NAVI_INCENTIVE_V3),
                                        txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    ],
                                });
                            }
                            rewardCoinSet.add(reward.rewardCoinType);
                        }
                    }
                    for (const reward of claimableRewards.get("0x0000000000000000000000000000000000000000000000000000000000000002::sui::SUI") || []) {
                        if (rewardCoinSet.has(reward.rewardCoinType) === false) {
                            if (reward.rewardCoinType === alphafi_sdk_1.coinsList["NAVX"].type) {
                                txb.moveCall({
                                    target: `${pool.packageId}::alphafi_navi_sui_vsui_investor::collect_reward_with_two_swaps_v2`,
                                    typeArguments: [alphafi_sdk_1.coinsList["NAVX"].type],
                                    arguments: [
                                        txb.object(pool.investorId),
                                        txb.object(C.ALPHA_2_VERSION),
                                        txb.object(C.CLOCK_PACKAGE_ID),
                                        txb.object(C.NAVI_STORAGE),
                                        txb.object(C.NAVI_INCENTIVE_V3),
                                        txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                        txb.object(C.VOLO_STAKE_POOL),
                                        txb.object(C.VOLO_METADATA),
                                        txb.object(C.SUI_SYSTEM_STATE),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`NAVX-SUI`]),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`VSUI-SUI`]),
                                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    ],
                                });
                            }
                            else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["VSUI"].type) {
                                txb.moveCall({
                                    target: `${pool.packageId}::alphafi_navi_sui_vsui_investor::collect_reward_with_no_swap`,
                                    arguments: [
                                        txb.object(pool.investorId),
                                        txb.object(C.ALPHA_2_VERSION),
                                        txb.object(C.CLOCK_PACKAGE_ID),
                                        txb.object(C.NAVI_STORAGE),
                                        txb.object(C.NAVI_INCENTIVE_V3),
                                        txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    ],
                                });
                            }
                            rewardCoinSet.add(reward.rewardCoinType);
                        }
                    }
                }
                txb.moveCall({
                    target: `${pool.packageId}::alphafi_navi_sui_vsui_pool::update_pool_v3`,
                    arguments: [
                        txb.object(C.ALPHA_2_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(C.NAVI_VSUI_POOL),
                        txb.object(C.NAVI_SUI_POOL),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                        txb.object(C.VOLO_STAKE_POOL),
                        txb.object(C.VOLO_METADATA),
                        txb.object(C.SUI_SYSTEM_STATE),
                        txb.object(C.KRIYA_VSUI_SUI_POOL),
                        txb.object(C.KRIYA_VERSION),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "NAVI-LOOP-USDC-USDT") {
                const claimableRewards = groupedRewards?.get(poolName);
                const rewardCoinSet = new Set();
                if (claimableRewards) {
                    for (const reward of claimableRewards.get(alphafi_sdk_1.coinsList[alphafi_sdk_1.loopingPoolCoinMap[poolName].supplyCoin].type) || []) {
                        if (rewardCoinSet.has(reward.rewardCoinType) === false) {
                            if (reward.rewardCoinType === alphafi_sdk_1.coinsList["NAVX"].type) {
                                txb.moveCall({
                                    target: `${pool.packageId}::alphafi_navi_native_usdc_usdt_investor::collect_reward_with_two_swaps`,
                                    typeArguments: [alphafi_sdk_1.coinsList["NAVX"].type],
                                    arguments: [
                                        txb.object(pool.investorId),
                                        txb.object(C.ALPHA_2_VERSION),
                                        txb.object(C.CLOCK_PACKAGE_ID),
                                        txb.object(C.NAVI_STORAGE),
                                        txb.object(C.NAVI_INCENTIVE_V3),
                                        txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`NAVX-SUI`]),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`USDC-SUI`]),
                                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    ],
                                });
                            }
                            else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["VSUI"].type) {
                                txb.moveCall({
                                    target: `${pool.packageId}::alphafi_navi_native_usdc_usdt_investor::collect_reward_with_two_swaps`,
                                    typeArguments: [alphafi_sdk_1.coinsList["VSUI"].type],
                                    arguments: [
                                        txb.object(pool.investorId),
                                        txb.object(C.ALPHA_2_VERSION),
                                        txb.object(C.CLOCK_PACKAGE_ID),
                                        txb.object(C.NAVI_STORAGE),
                                        txb.object(C.NAVI_INCENTIVE_V3),
                                        txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`VSUI-SUI`]),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`USDC-SUI`]),
                                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    ],
                                });
                            }
                            rewardCoinSet.add(reward.rewardCoinType);
                        }
                    }
                    for (const reward of claimableRewards.get(alphafi_sdk_1.coinsList[alphafi_sdk_1.loopingPoolCoinMap[poolName].borrowCoin].type) || []) {
                        if (rewardCoinSet.has(reward.rewardCoinType) === false) {
                            if (reward.rewardCoinType === alphafi_sdk_1.coinsList["NAVX"].type) {
                                txb.moveCall({
                                    target: `${pool.packageId}::alphafi_navi_native_usdc_usdt_investor::collect_reward_with_two_swaps`,
                                    typeArguments: [alphafi_sdk_1.coinsList["NAVX"].type],
                                    arguments: [
                                        txb.object(pool.investorId),
                                        txb.object(C.ALPHA_2_VERSION),
                                        txb.object(C.CLOCK_PACKAGE_ID),
                                        txb.object(C.NAVI_STORAGE),
                                        txb.object(C.NAVI_INCENTIVE_V3),
                                        txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`NAVX-SUI`]),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`USDC-SUI`]),
                                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    ],
                                });
                            }
                            else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["VSUI"].type) {
                                txb.moveCall({
                                    target: `${pool.packageId}::alphafi_navi_native_usdc_usdt_investor::collect_reward_with_two_swaps`,
                                    typeArguments: [alphafi_sdk_1.coinsList["VSUI"].type],
                                    arguments: [
                                        txb.object(pool.investorId),
                                        txb.object(C.ALPHA_2_VERSION),
                                        txb.object(C.CLOCK_PACKAGE_ID),
                                        txb.object(C.NAVI_STORAGE),
                                        txb.object(C.NAVI_INCENTIVE_V3),
                                        txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`VSUI-SUI`]),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`USDC-SUI`]),
                                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    ],
                                });
                            }
                            rewardCoinSet.add(reward.rewardCoinType);
                        }
                    }
                }
                txb.moveCall({
                    target: `${pool.packageId}::alphafi_navi_native_usdc_usdt_pool::update_pool_v2`,
                    arguments: [
                        txb.object(C.ALPHA_2_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(C.NAVI_USDC_POOL),
                        txb.object(C.NAVI_USDT_POOL),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "NAVI-LOOP-HASUI-SUI") {
                const claimableRewards = groupedRewards?.get(poolName);
                const rewardCoinSet = new Set();
                if (claimableRewards) {
                    for (const reward of claimableRewards.get(alphafi_sdk_1.coinsList[alphafi_sdk_1.loopingPoolCoinMap[poolName].supplyCoin].type) || []) {
                        if (rewardCoinSet.has(reward.rewardCoinType) === false) {
                            if (reward.rewardCoinType === alphafi_sdk_1.coinsList["NAVX"].type) {
                                txb.moveCall({
                                    target: `${pool.packageId}::alphafi_navi_hasui_sui_investor::collect_reward_with_two_swaps`,
                                    typeArguments: [alphafi_sdk_1.coinsList["NAVX"].type],
                                    arguments: [
                                        txb.object(pool.investorId),
                                        txb.object(C.ALPHA_2_VERSION),
                                        txb.object(C.CLOCK_PACKAGE_ID),
                                        txb.object(C.NAVI_STORAGE),
                                        txb.object(C.NAVI_INCENTIVE_V3),
                                        txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                        txb.object(C.HAEDEL_STAKING),
                                        txb.object(C.SUI_SYSTEM_STATE),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`NAVX-SUI`]),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`HASUI-SUI`]),
                                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    ],
                                });
                            }
                            else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["VSUI"].type) {
                                txb.moveCall({
                                    target: `${pool.packageId}::alphafi_navi_hasui_sui_investor::collect_reward_with_two_swaps`,
                                    typeArguments: [alphafi_sdk_1.coinsList["VSUI"].type],
                                    arguments: [
                                        txb.object(pool.investorId),
                                        txb.object(C.ALPHA_2_VERSION),
                                        txb.object(C.CLOCK_PACKAGE_ID),
                                        txb.object(C.NAVI_STORAGE),
                                        txb.object(C.NAVI_INCENTIVE_V3),
                                        txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                        txb.object(C.HAEDEL_STAKING),
                                        txb.object(C.SUI_SYSTEM_STATE),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`VSUI-SUI`]),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`HASUI-SUI`]),
                                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    ],
                                });
                            }
                            rewardCoinSet.add(reward.rewardCoinType);
                        }
                    }
                    for (const reward of claimableRewards.get("0x0000000000000000000000000000000000000000000000000000000000000002::sui::SUI") || []) {
                        if (rewardCoinSet.has(reward.rewardCoinType) === false) {
                            if (reward.rewardCoinType === alphafi_sdk_1.coinsList["NAVX"].type) {
                                txb.moveCall({
                                    target: `${pool.packageId}::alphafi_navi_hasui_sui_investor::collect_reward_with_two_swaps`,
                                    typeArguments: [alphafi_sdk_1.coinsList["NAVX"].type],
                                    arguments: [
                                        txb.object(pool.investorId),
                                        txb.object(C.ALPHA_2_VERSION),
                                        txb.object(C.CLOCK_PACKAGE_ID),
                                        txb.object(C.NAVI_STORAGE),
                                        txb.object(C.NAVI_INCENTIVE_V3),
                                        txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                        txb.object(C.HAEDEL_STAKING),
                                        txb.object(C.SUI_SYSTEM_STATE),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`NAVX-SUI`]),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`HASUI-SUI`]),
                                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    ],
                                });
                            }
                            else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["VSUI"].type) {
                                txb.moveCall({
                                    target: `${pool.packageId}::alphafi_navi_hasui_sui_investor::collect_reward_with_two_swaps`,
                                    typeArguments: [alphafi_sdk_1.coinsList["VSUI"].type],
                                    arguments: [
                                        txb.object(pool.investorId),
                                        txb.object(C.ALPHA_2_VERSION),
                                        txb.object(C.CLOCK_PACKAGE_ID),
                                        txb.object(C.NAVI_STORAGE),
                                        txb.object(C.NAVI_INCENTIVE_V3),
                                        txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                        txb.object(C.HAEDEL_STAKING),
                                        txb.object(C.SUI_SYSTEM_STATE),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`VSUI-SUI`]),
                                        txb.object(alphafi_sdk_1.cetusPoolMap[`HASUI-SUI`]),
                                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    ],
                                });
                            }
                            rewardCoinSet.add(reward.rewardCoinType);
                        }
                    }
                }
                txb.moveCall({
                    target: `${pool.packageId}::alphafi_navi_hasui_sui_pool::update_pool_v2`, // change package id for testing
                    arguments: [
                        txb.object(C.ALPHA_2_VERSION), // change  version object id for testing
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(C.NAVI_HASUI_POOL),
                        txb.object(C.NAVI_SUI_POOL),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(alphafi_sdk_1.cetusPoolMap["HASUI-SUI"]),
                        txb.object(C.HAEDEL_STAKING),
                        txb.object(C.SUI_SYSTEM_STATE),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
        }
        else {
            if (poolName === "NAVI-SUI") {
                const claimableRewards = groupedRewards?.get(poolName);
                if (claimableRewards) {
                    for (const reward of claimableRewards.get(alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type) || []) {
                        if (reward.rewardCoinType === alphafi_sdk_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_one_swap_bluefin`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(pool.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                    txb.object(alphafi_sdk_1.bluefinPoolMap["NAVX-SUI"]),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_one_swap`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(pool.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::update_pool`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(pool.parentPoolId),
                        txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "NAVI-USDT" ||
                poolName === "NAVI-WETH" ||
                poolName === "NAVI-USDY") {
                const claimableRewards = groupedRewards?.get(poolName);
                if (claimableRewards) {
                    for (const reward of claimableRewards.get(alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type) || []) {
                        if (reward.rewardCoinType === alphafi_sdk_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["WUSDC"].type,
                                    alphafi_sdk_1.coinsList["SUI"].type,
                                    alphafi_sdk_1.coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(pool.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(alphafi_sdk_1.cetusPoolMap["NAVX-SUI"]),
                                    txb.object(alphafi_sdk_1.cetusPoolMap["WUSDC-SUI"]),
                                    txb.object(alphafi_sdk_1.cetusPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-WUSDC`]),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["WUSDC"].type,
                                    alphafi_sdk_1.coinsList["SUI"].type,
                                    alphafi_sdk_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(pool.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                                    txb.object(alphafi_sdk_1.cetusPoolMap["WUSDC-SUI"]),
                                    txb.object(alphafi_sdk_1.cetusPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-WUSDC`]),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::update_pool`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(pool.parentPoolId),
                        txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "NAVI-VSUI") {
                const claimableRewards = groupedRewards?.get(poolName);
                if (claimableRewards) {
                    for (const reward of claimableRewards.get(alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type) || []) {
                        if (reward.rewardCoinType === alphafi_sdk_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_two_swaps_bluefin`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["SUI"].type,
                                    alphafi_sdk_1.coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(pool.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(alphafi_sdk_1.bluefinPoolMap["NAVX-SUI"]),
                                    txb.object(alphafi_sdk_1.bluefinPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_no_swap`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(pool.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::update_pool`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(pool.parentPoolId),
                        txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "NAVI-WUSDC") {
                const claimableRewards = groupedRewards?.get(poolName);
                if (claimableRewards) {
                    for (const reward of claimableRewards.get(alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type) || []) {
                        if (reward.rewardCoinType === alphafi_sdk_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["CETUS"].type,
                                    alphafi_sdk_1.coinsList["SUI"].type,
                                    alphafi_sdk_1.coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(pool.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(alphafi_sdk_1.cetusPoolMap["NAVX-SUI"]),
                                    txb.object(alphafi_sdk_1.cetusPoolMap["CETUS-SUI"]),
                                    txb.object(alphafi_sdk_1.cetusPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-CETUS`]),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["CETUS"].type,
                                    alphafi_sdk_1.coinsList["SUI"].type,
                                    alphafi_sdk_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(pool.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                                    txb.object(alphafi_sdk_1.cetusPoolMap["CETUS-SUI"]),
                                    txb.object(alphafi_sdk_1.cetusPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-CETUS`]),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::update_pool`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(pool.parentPoolId),
                        txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "NAVI-USDC") {
                const claimableRewards = groupedRewards?.get(poolName);
                if (claimableRewards) {
                    for (const reward of claimableRewards.get(alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type) || []) {
                        if (reward.rewardCoinType === alphafi_sdk_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_two_swaps`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["SUI"].type,
                                    alphafi_sdk_1.coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(pool.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(alphafi_sdk_1.cetusPoolMap["NAVX-SUI"]),
                                    txb.object(alphafi_sdk_1.cetusPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === alphafi_sdk_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_two_swaps`,
                                typeArguments: [
                                    alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    alphafi_sdk_1.coinsList["SUI"].type,
                                    alphafi_sdk_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(pool.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                                    txb.object(alphafi_sdk_1.cetusPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::update_pool`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(pool.parentPoolId),
                        txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else {
                txb.moveCall({
                    target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::update_pool_with_two_swaps`,
                    typeArguments: [
                        alphafi_sdk_1.coinsList[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin].type,
                        alphafi_sdk_1.coinsList["SUI"].type,
                        alphafi_sdk_1.coinsList["VSUI"].type,
                    ],
                    arguments: [
                        txb.object(C.VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(pool.parentPoolId),
                        txb.pure.u8(Number(alphafi_sdk_1.naviAssetMap[alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V1),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.NAVI_NAVX_FUNDS_POOL),
                        txb.object(C.NAVI_VSUI_FUNDS_POOL),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                        txb.object(alphafi_sdk_1.cetusPoolMap[`${alphafi_sdk_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
        }
    }
    else {
        if (pool.packageNumber === 2) {
            txb.moveCall({
                target: `${pool.packageId}::alphafi_cetus_sui_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_2_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(C.CETUS_REWARDER_GLOBAL_VAULT_ID),
                    txb.object(alphafi_sdk_1.cetusPoolMap[poolName]),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else {
            if (poolName === "ALPHA") {
                const type = C.ALPHA_COIN_TYPE;
                txb.moveCall({
                    target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphapool::get_pool_rewards_all`,
                    typeArguments: [type],
                    arguments: [
                        txb.object(C.VERSION),
                        txb.object(pool.poolId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName !== "HASUI-SUI") {
                const coinAName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1;
                const coinA = alphafi_sdk_1.coinsList[coinAName];
                const coinBName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2;
                const coinB = alphafi_sdk_1.coinsList[coinBName];
                if (coinBName === "SUI") {
                    txb.moveCall({
                        target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_cetus_sui_pool::update_pool`,
                        typeArguments: [coinA.type, coinB.type],
                        arguments: [
                            txb.object(C.VERSION),
                            txb.object(pool.poolId),
                            txb.object(pool.investorId),
                            txb.object(C.ALPHA_DISTRIBUTOR),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            txb.object(C.CETUS_REWARDER_GLOBAL_VAULT_ID),
                            txb.object(alphafi_sdk_1.cetusPoolMap["CETUS-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap[poolName]),
                            txb.object(C.CLOCK_PACKAGE_ID),
                        ],
                    });
                }
                else if (poolName === "WUSDC-WBTC" ||
                    poolName === "USDC-USDT" ||
                    poolName === "USDC-WUSDC" ||
                    poolName === "USDC-ETH") {
                    txb.moveCall({
                        target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_cetus_pool_base_a::update_pool`,
                        typeArguments: [coinA.type, coinB.type],
                        arguments: [
                            txb.object(C.VERSION),
                            txb.object(pool.poolId),
                            txb.object(pool.investorId),
                            txb.object(C.ALPHA_DISTRIBUTOR),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            txb.object(C.CETUS_REWARDER_GLOBAL_VAULT_ID),
                            txb.object(alphafi_sdk_1.cetusPoolMap[`${coinAName}-SUI`]),
                            txb.object(alphafi_sdk_1.cetusPoolMap["CETUS-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap[poolName]),
                            txb.object(C.CLOCK_PACKAGE_ID),
                        ],
                    });
                }
                else {
                    txb.moveCall({
                        target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_cetus_pool::update_pool`,
                        typeArguments: [coinA.type, coinB.type],
                        arguments: [
                            txb.object(C.VERSION),
                            txb.object(pool.poolId),
                            txb.object(pool.investorId),
                            txb.object(C.ALPHA_DISTRIBUTOR),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            txb.object(C.CETUS_REWARDER_GLOBAL_VAULT_ID),
                            txb.object(alphafi_sdk_1.cetusPoolMap[`${coinBName}-SUI`]),
                            txb.object(alphafi_sdk_1.cetusPoolMap["CETUS-SUI"]),
                            txb.object(alphafi_sdk_1.cetusPoolMap[poolName]),
                            txb.object(C.CLOCK_PACKAGE_ID),
                        ],
                    });
                }
            }
        }
    }
    return txb;
}
// do autocompound for pools with tvl >= 100,000 4 times a day
// for tvl >= 50,000 and < 100,000, do autocompound 3 times a day
// for tvl < 50,000 but not retired, do autocompound 3 times a day
// for tvl < 50,000 and retired, do not autocompound
async function getAutocompoundRequired(poolNames) {
    const poolsTvl = await getPoolsTvl(poolNames);
    const highTvlThreshold = 100000;
    const lowTvlThreshold = 50000;
    const bigPools = new Set();
    const smallPools = new Set();
    const eligiblePools = new Set();
    for (const [poolName, tvl] of Object.entries(poolsTvl)) {
        const tvlValue = parseFloat(tvl);
        if (tvlValue >= highTvlThreshold) {
            bigPools.add(poolName);
            eligiblePools.add(poolName);
        }
        else if (tvlValue >= lowTvlThreshold) {
            smallPools.add(poolName);
            eligiblePools.add(poolName);
        }
        else {
            // For TVL < $50K, check if pool is retired
            const pool = alphafi_sdk_1.poolInfo[poolName];
            if (!pool.retired) {
                // Not retired pools with TVL < $50K are treated like small pools (2 times a day)
                smallPools.add(poolName);
                eligiblePools.add(poolName);
            }
            // Retired pools with TVL < $50K are completely excluded
        }
    }
    const now = Date.now();
    const autocompoundNotRequired = new Set();
    const eligiblePoolsArray = Array.from(eligiblePools);
    const autocompoundEvents = await (0, alphafi_sdk_1.fetchAutoCompoundingEvents)({
        startTime: now - 8 * 60 * 60 * 1000,
        endTime: now,
        poolNames: eligiblePoolsArray,
    });
    const investorPoolMap = (0, alphafi_sdk_1.getInvestorPoolMap)();
    autocompoundEvents.forEach((e) => {
        const poolName = investorPoolMap.get(e.investor_id);
        if (!poolName)
            return;
        const timeAgo = now - e.timestamp;
        if ((bigPools.has(poolName) && timeAgo < 6 * 60 * 60 * 1000) ||
            smallPools.has(poolName))
            autocompoundNotRequired.add(poolName);
    });
    console.log("all poolNames:", poolNames, "autocompound required poolNames:", eligiblePoolsArray.filter((poolName) => !autocompoundNotRequired.has(poolName)));
    // Only return pools that are eligible (TVL >= $50K) and not marked as not required
    return eligiblePoolsArray.filter((poolName) => !autocompoundNotRequired.has(poolName));
}
async function getPoolsTvl(poolNames) {
    const poolsTvl = {};
    await Promise.all(poolNames.map(async (poolName) => {
        const tvl = await (0, index_js_1.fetchTVL)(poolName, false);
        poolsTvl[poolName] = tvl;
    }));
    return poolsTvl;
}
//# sourceMappingURL=autocompound.js.map